import React, { FC, useCallback, useEffect, useState } from 'react'
import './HomeLandingAdmin.scss'
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb';
import { useTranslation } from 'react-i18next';
import ReferenceFormModule from 'app_components/modules/admin/landings/referencesForm/index';
import LandingService from 'app_services/admin/landings/landingService';
import { ILanding } from 'app_types/admin/landings/landingTypes';
import LoadingWrapper from 'app_components/commons/LoadingWrapper/LoadingWrapper';

const HOME_SLUG = 'home'

interface IHomeLandingAdminProps {

}

const HomeLandingAdmin: FC<IHomeLandingAdminProps> = () => {
  const { t } = useTranslation()
  const [landing, setLanding] = useState<ILanding | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(false)

  const fetchData = useCallback(async () => {
    const landingService = new LandingService()
    let httpParams: any = {
      slug: HOME_SLUG
    }
    setIsLoading(true)
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      setLanding(landingResponse)
    }
    setIsLoading(false)
  }, [])

  const onHandleSchedulingSubmit = useCallback((data: any) => {
    if (data.status === 'success') {
      fetchData()
    }
  }, [fetchData])

  useEffect(() => {
    fetchData()
  }, [fetchData])

  return (
    <AppContainer>
      <div className="home-landing-admin--layout">
        <BreadcrumbComponent links={['/admin/landings', '#']} texts={[`${t('components.breadcrumb.landings')}`, 'Home']} />
        <LoadingWrapper loading={isLoading}>
          <>
            <div className="row">
              <div className="col-6">
                <ReferenceFormModule
                  data={landing?.landing?.references}
                  source={HOME_SLUG}
                  onHandleSaved={onHandleSchedulingSubmit}
                  landingInfo={landing}
                />
              </div>
            </div>
          </>
        </LoadingWrapper>
      </div>
    </AppContainer>
  )
}

export default HomeLandingAdmin
